import React, { useState, useEffect } from "react";
import Dropdown from "../../components/Dropdown";

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

function DeliveryMethodsNonmetallic({ deliveryMethod, setDeliveryMethod, selectedRegion }) {
  const [deliveryOptions, setDeliveryOptions] = useState({});

  useEffect(() => {
    console.log("🚚 DeliveryMethodsNonmetallic текущее состояние deliveryOptions:", deliveryOptions);
  }, [deliveryOptions]);

  useEffect(() => {
    console.log("🚚 DeliveryMethodsNonmetallic useEffect, selectedRegion:", selectedRegion);

    if (!selectedRegion) {
      console.log("🚚 selectedRegion пустой, прерываем выполнение");
      return;
    }

    const fetchDeliveryOptions = async () => {
      try {
        const response = await fetch(`${PATH_TO_BACKEND}/api/deliveryMethods?region=${selectedRegion}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("🚚 ПОЛНЫЙ ответ API для нерудки:", JSON.stringify(data, null, 2));

        if (data.success && data.data) {
          console.log("🚚 data.data:", JSON.stringify(data.data, null, 2));

          // Извлекаем только опции для нерудки
          const nerOptions = data.data.ner || {};
          console.log("🚚 nerOptions до установки:", nerOptions);

          if (nerOptions && Object.keys(nerOptions).length > 0) {
            setDeliveryOptions({ ner: nerOptions });
            console.log("🚚 Установлены опции для нерудки:", nerOptions);
          } else {
            console.log("🚚 nerOptions пустой, используем fallback");
            throw new Error("Нет опций для нерудки в ответе API");
          }
        } else {
          console.log("🚚 Некорректная структура ответа API");
          throw new Error("Некорректный ответ API");
        }
      } catch (error) {
        console.error("❌ Ошибка при загрузке опций доставки для нерудки:", error);

        // Fallback опции для нерудки
        console.log("🚚 Используем fallback опции для нерудки");
        setDeliveryOptions({
          ner: {
            "Манипулятор": {},
            "Самосвал": {}
          }
        });
      }
    };

    fetchDeliveryOptions();
  }, [selectedRegion]);

  const handleDeliveryMethodChange = (category, value) => {
    console.log(`🚚 DeliveryMethodsNonmetallic изменение способа доставки: ${category} -> ${value}`);
    console.log(`🚚 deliveryMethod до изменения:`, deliveryMethod);

    // Если deliveryMethod - строка, передаем её напрямую, иначе создаем объект
    if (typeof deliveryMethod === 'string' || deliveryMethod === null || deliveryMethod === undefined) {
      console.log(`🚚 deliveryMethod is string, setting to: ${value}`);
      setDeliveryMethod(value);
    } else {
      setDeliveryMethod(prevMethod => {
        const newMethod = {
          ...prevMethod,
          [category]: value
        };
        console.log(`🚚 deliveryMethod после изменения:`, newMethod);
        return newMethod;
      });
    }
  };

  return (
    <div className="delivery-methods-nonmetallic mkr-slider-container">
      <div className="mkr-slider-title">Способ доставки</div>

      {deliveryOptions.ner && (Array.isArray(deliveryOptions.ner) ? deliveryOptions.ner.length > 0 : Object.keys(deliveryOptions.ner).length > 0) ? (
        <div className="mb-2">
          <Dropdown
            value={typeof deliveryMethod === 'string' ? deliveryMethod : (deliveryMethod?.ner || "Оптимальный маршрут")}
            onChange={(e) => handleDeliveryMethodChange("ner", e.target.value)}
            align="left"
            maxWidth="300px"
          >
            <option value="Оптимальный маршрут">Оптимальный маршрут</option>
            {Array.isArray(deliveryOptions.ner)
              ? deliveryOptions.ner.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
              : Object.keys(deliveryOptions.ner).map((optionKey) => (
                  <option key={optionKey} value={optionKey}>
                    {optionKey}
                  </option>
                ))
            }
          </Dropdown>
          {/* <small className="text-muted">
            Найдено {Array.isArray(deliveryOptions.ner) ? deliveryOptions.ner.length : Object.keys(deliveryOptions.ner).length} способов доставки
          </small> */}
        </div>
      ) : (
        <div className="mb-2">
          <small className="text-danger">Нет доступных способов доставки для нерудки</small>
        </div>
      )}

      {Object.keys(deliveryOptions).length === 0 && (
        <div className="text-muted">
          <small>Загрузка способов доставки...</small>
        </div>
      )}
    </div>
  );
}

export default DeliveryMethodsNonmetallic;